import React, { useEffect, useRef } from 'react';

import { useStore } from '../../zustand/stores';
import { PageData } from '../PageTemplate';

type PageDataSyncProps = {
  pageData?: PageData;
  itemId?: string;
  itemType?: string;
  hasError?: boolean;
  children: React.ReactNode;
};

export const PageDataSync = ({
  pageData,
  itemId,
  itemType,
  hasError,
  children,
}: PageDataSyncProps) => {
  const setPageMeta = useStore((s) => s.pageSlice.setPageMeta);
  const setArticleData = useStore((s) => s.articleSlice.setArticleData);
  const setCategoryData = useStore((s) => s.categorySlice.setCategoryData);
  const setRoadmapData = useStore((s) => s.roadmapSlice.setRoadmapData);

  const first = useRef(true);
  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    setPageMeta({
      itemId,
      itemType,
      hasError: hasError || false,
      searchResults: pageData?.searchResults,
      term: pageData?.term,
    });
    setArticleData({
      article: pageData?.article,
      translations: pageData?.translations,
    });
    setCategoryData({
      category: pageData?.category,
      translations: pageData?.translations,
    });
    setRoadmapData({
      sortType: pageData?.roadmapData?.sortType,
      roadmapFilter: pageData?.roadmapData?.roadmapFilter,
      resolution: pageData?.roadmapData?.resolution,
      roadmapLabels: pageData?.roadmapData?.roadmapLabels,
      label: pageData?.roadmapData?.label,
    });
  }, [pageData, itemId, itemType, hasError, setPageMeta, setArticleData, setCategoryData, setRoadmapData]);

  return <>{children}</>;
};
